import { HttpContextToken } from '@angular/common/http';

/**
 * Cuando es `true`, el `errorInterceptor` NO muestra un toast de error para ese request:
 * el componente maneja el error por su cuenta. Se usa en los flujos de recuperación de
 * contraseña (forgot/reset) para no surfacear el mensaje crudo del backend y así no
 * degradar la genericidad anti-enumeración (LION-517): el componente muestra un mensaje
 * genérico fijo independientemente de la respuesta.
 *
 * Vive en su propio archivo (no en error.interceptor) para evitar un ciclo de imports:
 * auth.service ↔ error.interceptor.
 */
export const SKIP_ERROR_TOAST = new HttpContextToken<boolean>(() => false);

/**
 * Cuando es `true`, el `errorInterceptor` NO ejecuta `auth.logout()` ante un 401 de
 * ese request. Se usa en el flujo de step-up (segundo factor de aprobaciones): el
 * desafío y la verificación responden 401 como parte NORMAL del flujo (código TOTP
 * incorrecto, segundo factor requerido) y deben manejarse en el componente/modal,
 * no echar al usuario. Sin esto, un código mal tipeado desloguearía al aprobador.
 */
export const SKIP_AUTH_LOGOUT = new HttpContextToken<boolean>(() => false);
